module.exports = __webpack_public_path__ + "img/joachim_gauster.56683fca.jpg";